import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React from 'react'

import { PhotoReelButton } from './PhotoReelButton'

export const PhotoReel: React.FC = () => {
  const { kestrelModel } = useKestrelViewerContext()
  const { setHelperTextVisible, photoReelOpen, setPhotoReelOpen } =
    useKestrelViewerContext()

  const handleToggle = () => {
    const newIsOpen = !photoReelOpen
    setPhotoReelOpen(newIsOpen)

    // If photo mode is being opened, close the helper text
    if (newIsOpen) {
      setHelperTextVisible(false)
    }
  }

  if (!kestrelModel?.id || !kestrelModel?.data.photosEnabled) {
    return null
  }

  return (
    <>
      <PhotoReelButton onToggle={handleToggle} isOpen={photoReelOpen} />
    </>
  )
}
